module.exports = __webpack_public_path__ + "static/media/hamamo_top_logo_baydiamond.88237ebb.png";